import React, { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { ThemeProvider, Link } from "@material-ui/core";
import GlobalStyles from "src/components/GlobalStyles";
import { getGlobalTheme } from "src/theme";
import { routes, routesPublicVoting } from "src/routes";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import CookieConsent from "react-cookie-consent";
import { getSystemLabel } from "src/constant/Messages";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const App = ({ globalData, hideSnackbar, ...rest }) => {
  const routing = useRoutes(
    process.env.REACT_APP_PUBLIC_VOIDING === "true" ? routesPublicVoting : routes
  );
  const [theme, setTheme] = useState(
    getGlobalTheme(
      localStorage.getItem("wcagcontr") === "1",
      localStorage.getItem("wcagfont") === "1"
    )
  );

  useEffect(() => {
    setTheme(
      getGlobalTheme(
        localStorage.getItem("wcagcontr") === "1",
        localStorage.getItem("wcagfont") === "1"
      )
    );

    return () => {};
  }, [globalData.wcagflags]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    hideSnackbar();
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
      <CookieConsent
        location="bottom"
        buttonText="Akceptuję"
        cookieName="kmCookieAccept"
        style={{
          background: theme.palette.common.cookieBackground,
          zIndex: 1300,
          border: "2px solid",
          borderColor: theme.palette.common.cookieBorder,
          fontSize: theme.largeFont ? "1.3125rem" : "0.875rem",
        }}
        buttonStyle={{
          color: theme.palette.common.white,
          background: theme.palette.common.cookieButton,
          fontSize: theme.largeFont ? "28px" : "19px",
        }}
        expires={150}
      >
        Portal Komitetu Monitorującego{" "}
        {getSystemLabel("program", globalData.systemInfo)} używa plików cookies,
        aby ułatwić Internautom korzystanie z naszej strony www oraz do celów
        statystycznych. Jeśli nie blokujesz tych plików, to zgadzasz się na ich
        użycie oraz zapisanie w pamięci Twojego komputera. Pamiętaj, że możesz
        samodzielnie zmienić ustawienia przeglądarki tak, aby zablokować
        zapisywanie plików cookies. Więcej informacji znajdziesz w{" "}
        <Link
          style={{ color: theme.palette.secondary.main }}
          href="/pomoc/politykaprywatnosci"
        >
          <b>Polityce prywatności</b>
        </Link>
      </CookieConsent>
      <Snackbar
        open={globalData.snackBarParameters.isOpen}
        autoHideDuration={globalData.snackBarParameters.autoHideDuration}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={globalData.snackBarParameters.severity}
        >
          {globalData.snackBarParameters.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  hideSnackbar: () => dispatch(actions.hideSnackbar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
